import PropTypes from 'prop-types'

import styled from '@emotion/styled'

const HeroWrapper = styled.div({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '50%',
})

const HeroImage = styled.img({
  width: '100%',
  height: '100%',
  objectFit: 'scale-down',
})

const FallbackHeroSection = ({ src }) => (
  <HeroWrapper>
    <HeroImage data-fallback="true" data-test="FallbackHeroSection" src={src} />
  </HeroWrapper>
)

FallbackHeroSection.propTypes = {
  src: PropTypes.string.isRequired,
}

FallbackHeroSection.displayName = 'FallbackHeroSection'
FallbackHeroSection.whyDidYouRender = true

export default FallbackHeroSection
